import { Component, ElementRef, inject, OnInit, ViewChild } from '@angular/core';


import { HttpClient } from '@angular/common/http';

import { anyU } from 'src/app/models/anyU';
import { environment } from 'src/environments/environment';
import { commandU } from 'src/app/models/commandU';
declare var bootstrap: any;


@Component({
  selector: 'app-command',
  templateUrl: './command.component.html',
  styleUrls: ['./command.component.css']
})
export class CommandComponent {

 baseUrl = environment.apiBaseUrl;
  @ViewChild('userModal') userModal: ElementRef | undefined;

  //u3
  @ViewChild('detailModal') detailModal!: ElementRef;
  detailObj: any = null;
  searchText: string = '';
  filteredList: any[] = [];


  anyList: any[] = [];
  anyObj: any ={
      "id":0,
      "title":"",
      "description":"",
      "wich_kind":"",


  }
  http = inject(HttpClient);

   ngOnInit(): void {
  this.getAllcommand()
  }

  // constructor(private userService: Service) {}

  openModal(): void {
  // console.log("openModal triggered");
  if (this.userModal) {
    const modal = new bootstrap.Modal(this.userModal.nativeElement);
    modal.show();
  } else {
    // console.warn("userModal is undefined!");
  }
}

//u3
openDetailModal(item: any): void {
  this.detailObj = item;

  const modal = new bootstrap.Modal(this.detailModal.nativeElement);
  modal.show();
}

closeModal(): void {
  if (this.userModal) {
    const modal = bootstrap.Modal.getInstance(this.userModal.nativeElement);
    if (modal) modal.hide();
  }
}

  getAllcommand(): void {

    this.http.get<commandU[]>(`${this.baseUrl}/command`).subscribe((res) => {
      this.anyList = res;
       //u3
      this.filteredList = res;
      // console.log(this.anyList); // چاپ داده‌ها برای بررسی
    });
  }
  //u3
  onSearch(): void {
      const text = this.searchText.toLowerCase().trim();
      this.filteredList = this.anyList.filter(item =>
        item.title.toLowerCase().includes(text) ||
        item.description.toLowerCase().includes(text)
      );
    }

  onSave(): void {
  if (this.anyObj.id === 0) {
    // افزودن
    const newUser = { ...this.anyObj };
    delete newUser.id; // ← ID را حذف کن که نره به سرور

    this.http.post<commandU>(`${this.baseUrl}/command`, newUser).subscribe((res) => {
      this.getAllcommand();
      this.closeModal();
    });
  } else {
    // ویرایش
    // this.http.put<anyU>(`${this.baseUrl}/mythings/${this.anyObj.id}`, this.anyObj).subscribe((res) => {

    this.http.post<commandU>(`${this.baseUrl}/command/update`, this.anyObj).subscribe((res) => {
      this.getAllcommand();
      this.closeModal();
    });
  }
}


  // باز کردن مدال برای ویرایش
  openEditModal(user: any): void {
    this.anyObj = { ...user }; // پر کردن فیلدها با داده‌های دستور انتخاب‌شده
    this.openModal();
  }

  // حذف دستور
  delete(Id: number): void {
    if (confirm("آیا مطمئن هستید که می‌خواهید این دستور را حذف کنید؟")) {
      // this.http.delete(`${this.baseUrl}/mythings/${Id}`).subscribe(() => {
        // this.http.post(`${this.baseUrl}/mythings/delete`, Id).subscribe(() => {
        this.http.post(`${this.baseUrl}/command/delete/${Id}`, null).subscribe(() => {

        this.getAllcommand(); // بعد از حذف، لیست دستور را مجدد بگیر
      });
    }
  }

  fixUrl(url: string): string {
  if (!url) return '';
  if (url.startsWith('http://') || url.startsWith('https://')) {
    return url;
  }
  return 'http://' + url;
}


}


